<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7545_7412)">
      <path d="M25.8502 2.69544C25.9267 2.62077 26.0446 2.60056 26.1272 2.66838C26.3003 2.81052 26.4688 3.06149 26.4688 3.46045V26.0034C26.4688 28.3506 24.566 30.2534 22.2188 30.2534H7.4375V29.4253H6.54688V3.25787C6.59785 2.94067 6.76497 2.74147 6.92284 2.63028C7.00362 2.57338 7.11069 2.59445 7.18282 2.66198L8.11536 3.535C8.27155 3.68121 8.51508 3.67865 8.66815 3.52921L9.71033 2.51163C9.78754 2.43625 9.89117 2.39404 9.99902 2.39404C10.1039 2.39404 10.2049 2.43393 10.2815 2.50562L11.381 3.535C11.5372 3.68121 11.7807 3.67865 11.9338 3.52921L12.976 2.51163C13.0532 2.43625 13.1568 2.39404 13.2646 2.39404C13.3696 2.39404 13.4705 2.43393 13.5471 2.50562L14.6466 3.535C14.8028 3.68121 15.0463 3.67865 15.1994 3.52921L16.2416 2.51163C16.3188 2.43625 16.4224 2.39404 16.5303 2.39404C16.6352 2.39404 16.7361 2.43393 16.8127 2.50562L17.9122 3.535C18.0684 3.68121 18.312 3.67865 18.465 3.52921L19.5072 2.51163C19.5844 2.43625 19.688 2.39404 19.7959 2.39404C19.9008 2.39404 20.0018 2.43393 20.0784 2.50562L21.1779 3.535C21.334 3.68121 21.5776 3.67865 21.7307 3.52921L22.7728 2.51163C22.85 2.43625 22.9537 2.39404 23.0615 2.39404C23.1664 2.39404 23.2674 2.43393 23.344 2.50562L24.4435 3.535C24.5997 3.68121 24.8432 3.67865 24.9963 3.52921L25.8502 2.69544Z"
            fill="url(#paint0_linear_7545_7412)"
      />
      <path d="M25.8502 2.69544C25.9267 2.62077 26.0446 2.60056 26.1272 2.66838C26.3003 2.81052 26.4688 3.06149 26.4688 3.46045V26.0034C26.4688 28.3506 24.566 30.2534 22.2188 30.2534H7.4375V29.4253H6.54688V3.25787C6.59785 2.94067 6.76497 2.74147 6.92284 2.63028C7.00362 2.57338 7.11069 2.59445 7.18282 2.66198L8.11536 3.535C8.27155 3.68121 8.51508 3.67865 8.66815 3.52921L9.71033 2.51163C9.78754 2.43625 9.89117 2.39404 9.99902 2.39404C10.1039 2.39404 10.2049 2.43393 10.2815 2.50562L11.381 3.535C11.5372 3.68121 11.7807 3.67865 11.9338 3.52921L12.976 2.51163C13.0532 2.43625 13.1568 2.39404 13.2646 2.39404C13.3696 2.39404 13.4705 2.43393 13.5471 2.50562L14.6466 3.535C14.8028 3.68121 15.0463 3.67865 15.1994 3.52921L16.2416 2.51163C16.3188 2.43625 16.4224 2.39404 16.5303 2.39404C16.6352 2.39404 16.7361 2.43393 16.8127 2.50562L17.9122 3.535C18.0684 3.68121 18.312 3.67865 18.465 3.52921L19.5072 2.51163C19.5844 2.43625 19.688 2.39404 19.7959 2.39404C19.9008 2.39404 20.0018 2.43393 20.0784 2.50562L21.1779 3.535C21.334 3.68121 21.5776 3.67865 21.7307 3.52921L22.7728 2.51163C22.85 2.43625 22.9537 2.39404 23.0615 2.39404C23.1664 2.39404 23.2674 2.43393 23.344 2.50562L24.4435 3.535C24.5997 3.68121 24.8432 3.67865 24.9963 3.52921L25.8502 2.69544Z"
            fill="url(#paint1_radial_7545_7412)"
      />
      <path d="M25.8502 2.69544C25.9267 2.62077 26.0446 2.60056 26.1272 2.66838C26.3003 2.81052 26.4688 3.06149 26.4688 3.46045V26.0034C26.4688 28.3506 24.566 30.2534 22.2188 30.2534H7.4375V29.4253H6.54688V3.25787C6.59785 2.94067 6.76497 2.74147 6.92284 2.63028C7.00362 2.57338 7.11069 2.59445 7.18282 2.66198L8.11536 3.535C8.27155 3.68121 8.51508 3.67865 8.66815 3.52921L9.71033 2.51163C9.78754 2.43625 9.89117 2.39404 9.99902 2.39404C10.1039 2.39404 10.2049 2.43393 10.2815 2.50562L11.381 3.535C11.5372 3.68121 11.7807 3.67865 11.9338 3.52921L12.976 2.51163C13.0532 2.43625 13.1568 2.39404 13.2646 2.39404C13.3696 2.39404 13.4705 2.43393 13.5471 2.50562L14.6466 3.535C14.8028 3.68121 15.0463 3.67865 15.1994 3.52921L16.2416 2.51163C16.3188 2.43625 16.4224 2.39404 16.5303 2.39404C16.6352 2.39404 16.7361 2.43393 16.8127 2.50562L17.9122 3.535C18.0684 3.68121 18.312 3.67865 18.465 3.52921L19.5072 2.51163C19.5844 2.43625 19.688 2.39404 19.7959 2.39404C19.9008 2.39404 20.0018 2.43393 20.0784 2.50562L21.1779 3.535C21.334 3.68121 21.5776 3.67865 21.7307 3.52921L22.7728 2.51163C22.85 2.43625 22.9537 2.39404 23.0615 2.39404C23.1664 2.39404 23.2674 2.43393 23.344 2.50562L24.4435 3.535C24.5997 3.68121 24.8432 3.67865 24.9963 3.52921L25.8502 2.69544Z"
            fill="url(#paint2_linear_7545_7412)"
      />
      <path d="M25.8502 2.69544C25.9267 2.62077 26.0446 2.60056 26.1272 2.66838C26.3003 2.81052 26.4688 3.06149 26.4688 3.46045V26.0034C26.4688 28.3506 24.566 30.2534 22.2188 30.2534H7.4375V29.4253H6.54688V3.25787C6.59785 2.94067 6.76497 2.74147 6.92284 2.63028C7.00362 2.57338 7.11069 2.59445 7.18282 2.66198L8.11536 3.535C8.27155 3.68121 8.51508 3.67865 8.66815 3.52921L9.71033 2.51163C9.78754 2.43625 9.89117 2.39404 9.99902 2.39404C10.1039 2.39404 10.2049 2.43393 10.2815 2.50562L11.381 3.535C11.5372 3.68121 11.7807 3.67865 11.9338 3.52921L12.976 2.51163C13.0532 2.43625 13.1568 2.39404 13.2646 2.39404C13.3696 2.39404 13.4705 2.43393 13.5471 2.50562L14.6466 3.535C14.8028 3.68121 15.0463 3.67865 15.1994 3.52921L16.2416 2.51163C16.3188 2.43625 16.4224 2.39404 16.5303 2.39404C16.6352 2.39404 16.7361 2.43393 16.8127 2.50562L17.9122 3.535C18.0684 3.68121 18.312 3.67865 18.465 3.52921L19.5072 2.51163C19.5844 2.43625 19.688 2.39404 19.7959 2.39404C19.9008 2.39404 20.0018 2.43393 20.0784 2.50562L21.1779 3.535C21.334 3.68121 21.5776 3.67865 21.7307 3.52921L22.7728 2.51163C22.85 2.43625 22.9537 2.39404 23.0615 2.39404C23.1664 2.39404 23.2674 2.43393 23.344 2.50562L24.4435 3.535C24.5997 3.68121 24.8432 3.67865 24.9963 3.52921L25.8502 2.69544Z"
            fill="url(#paint3_linear_7545_7412)"
      />
      <path d="M26.3226 3.66459C26.2566 3.25098 26.2963 3.01218 26.1232 2.87005C26.0406 2.80222 25.9227 2.82243 25.8462 2.8971L24.9923 3.73087C24.8392 3.88031 24.5957 3.88287 24.4395 3.73666L23.34 2.70728C23.2634 2.63559 23.1625 2.5957 23.0575 2.5957C22.9497 2.5957 22.8461 2.63791 22.7688 2.71329L21.7267 3.73087C21.5736 3.88031 21.3301 3.88287 21.1739 3.73666L20.0744 2.70728C19.9978 2.63559 19.8968 2.5957 19.7919 2.5957C19.6841 2.5957 19.5804 2.63791 19.5032 2.71329L18.461 3.73087C18.308 3.88031 18.0644 3.88287 17.9083 3.73666L16.8088 2.70728C16.7322 2.63559 16.6312 2.5957 16.5263 2.5957C16.4184 2.5957 16.3148 2.63791 16.2376 2.71329L15.1954 3.73087C15.0423 3.88031 14.7988 3.88287 14.6426 3.73666L13.5431 2.70728C13.4665 2.63559 13.3656 2.5957 13.2607 2.5957C13.1528 2.5957 13.0492 2.63791 12.972 2.71329L11.9298 3.73087C11.7767 3.88031 11.5332 3.88287 11.377 3.73666L10.2775 2.70728C10.2009 2.63559 10.1 2.5957 9.99504 2.5957C9.88719 2.5957 9.78356 2.63791 9.70635 2.71329L8.66417 3.73087C8.51109 3.88031 8.26756 3.88287 8.11138 3.73666L7.17884 2.86364C7.10671 2.79611 7.01382 2.80674 6.93305 2.86364C6.77518 2.97483 6.70942 3.12432 6.65845 3.44153"
            stroke="url(#paint4_linear_7545_7412)"
            stroke-opacity="0.7"
            stroke-width="0.2"
      />
      <path d="M18.638 26.2847C18.638 25.7324 18.1903 25.2847 17.638 25.2847H4.54062C3.99179 25.2847 3.54688 25.7296 3.54688 26.2784C3.54688 28.4738 5.32654 30.2534 7.52188 30.2534H21.6713C19.276 30.0406 18.6626 27.7053 18.638 26.3726V26.2847Z"
            fill="url(#paint5_linear_7545_7412)"
      />
      <path d="M18.638 26.2847C18.638 25.7324 18.1903 25.2847 17.638 25.2847H4.54062C3.99179 25.2847 3.54688 25.7296 3.54688 26.2784C3.54688 28.4738 5.32654 30.2534 7.52188 30.2534H21.6713C19.276 30.0406 18.6626 27.7053 18.638 26.3726V26.2847Z"
            fill="url(#paint6_linear_7545_7412)"
      />
      <path d="M18.638 26.2847C18.638 25.7324 18.1903 25.2847 17.638 25.2847H4.54062C3.99179 25.2847 3.54688 25.7296 3.54688 26.2784C3.54688 28.4738 5.32654 30.2534 7.52188 30.2534H21.6713C19.276 30.0406 18.6626 27.7053 18.638 26.3726V26.2847Z"
            fill="url(#paint7_radial_7545_7412)"
      />
      <path d="M9.54688 7.33936C9.54688 6.80001 9.9841 6.36279 10.5234 6.36279H22.5234C23.0628 6.36279 23.5 6.80001 23.5 7.33936C23.5 7.8787 23.0628 8.31592 22.5234 8.31592H10.5234C9.9841 8.31592 9.54688 7.8787 9.54688 7.33936Z"
            fill="#97939D"
      />
      <path d="M9.54688 10.8472C9.54688 10.5624 9.77773 10.3315 10.0625 10.3315H17.9688C18.2535 10.3315 18.4844 10.5624 18.4844 10.8472C18.4844 11.1319 18.2535 11.3628 17.9688 11.3628H10.0625C9.77773 11.3628 9.54688 11.1319 9.54688 10.8472Z"
            fill="#97939D"
      />
      <path d="M9.54688 13.8159C9.54688 13.5311 9.77773 13.3003 10.0625 13.3003H17.9688C18.2535 13.3003 18.4844 13.5311 18.4844 13.8159C18.4844 14.1007 18.2535 14.3315 17.9688 14.3315H10.0625C9.77773 14.3315 9.54688 14.1007 9.54688 13.8159Z"
            fill="#97939D"
      />
      <path d="M9.54688 16.8394C9.54688 16.5546 9.77773 16.3237 10.0625 16.3237H17.9688C18.2535 16.3237 18.4844 16.5546 18.4844 16.8394C18.4844 17.1241 18.2535 17.355 17.9688 17.355H10.0625C9.77773 17.355 9.54688 17.1241 9.54688 16.8394Z"
            fill="#97939D"
      />
      <path d="M9.54688 19.8628C9.54688 19.578 9.77773 19.3472 10.0625 19.3472H17.9688C18.2535 19.3472 18.4844 19.578 18.4844 19.8628C18.4844 20.1476 18.2535 20.3784 17.9688 20.3784H10.0625C9.77773 20.3784 9.54688 20.1476 9.54688 19.8628Z"
            fill="#97939D"
      />
      <path d="M9.54688 22.8862C9.54688 22.6015 9.77773 22.3706 10.0625 22.3706H17.9688C18.2535 22.3706 18.4844 22.6015 18.4844 22.8862C18.4844 23.171 18.2535 23.4019 17.9688 23.4019H10.0625C9.77773 23.4019 9.54688 23.171 9.54688 22.8862Z"
            fill="#97929F"
      />
      <path d="M19.5156 13.8159C19.5156 13.5311 19.7465 13.3003 20.0312 13.3003H22.9844C23.2691 13.3003 23.5 13.5311 23.5 13.8159C23.5 14.1007 23.2691 14.3315 22.9844 14.3315H20.0312C19.7465 14.3315 19.5156 14.1007 19.5156 13.8159Z"
            fill="#97939D"
      />
      <path d="M19.5156 10.8472C19.5156 10.5624 19.7465 10.3315 20.0312 10.3315H22.9844C23.2691 10.3315 23.5 10.5624 23.5 10.8472C23.5 11.1319 23.2691 11.3628 22.9844 11.3628H20.0312C19.7465 11.3628 19.5156 11.1319 19.5156 10.8472Z"
            fill="#97939D"
      />
      <path d="M19.5156 16.8394C19.5156 16.5546 19.7465 16.3237 20.0312 16.3237H22.9844C23.2691 16.3237 23.5 16.5546 23.5 16.8394C23.5 17.1241 23.2691 17.355 22.9844 17.355H20.0312C19.7465 17.355 19.5156 17.1241 19.5156 16.8394Z"
            fill="#97939D"
      />
      <path d="M19.5156 19.8628C19.5156 19.578 19.7465 19.3472 20.0312 19.3472H22.9844C23.2691 19.3472 23.5 19.578 23.5 19.8628C23.5 20.1476 23.2691 20.3784 22.9844 20.3784H20.0312C19.7465 20.3784 19.5156 20.1476 19.5156 19.8628Z"
            fill="#97939D"
      />
      <path d="M19.5156 22.8862C19.5156 22.6015 19.7465 22.3706 20.0312 22.3706H22.9844C23.2691 22.3706 23.5 22.6015 23.5 22.8862C23.5 23.171 23.2691 23.4019 22.9844 23.4019H20.0312C19.7465 23.4019 19.5156 23.171 19.5156 22.8862Z"
            fill="#9893A0"
      />
      <path d="M26.3554 25.8857C26.3554 28.4001 24.6012 30.1357 22.1054 30.1357H21.2378"
            stroke="url(#paint8_linear_7545_7412)"
            stroke-width="0.2"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7545_7412"
                      x1="8.5"
                      y1="17.0034"
                      x2="26.4688"
                      y2="17.0034"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DFD8E8" />
        <stop offset="1"
              stop-color="#E0DBEA"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_7545_7412"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.7781 30.2534) rotate(-60.1007) scale(5.33509 8.36541)"
      >
        <stop stop-color="#F9F3FE" />
        <stop offset="1"
              stop-color="#F9F3FE"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint2_linear_7545_7412"
                      x1="26.4687"
                      y1="22.529"
                      x2="25.9726"
                      y2="22.529"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCF9FF" />
        <stop offset="1"
              stop-color="#FCF9FF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7545_7412"
                      x1="6.54687"
                      y1="22.529"
                      x2="7.01974"
                      y2="22.529"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBB8C3" />
        <stop offset="1"
              stop-color="#C7C1CF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7545_7412"
                      x1="26.3226"
                      y1="2.5957"
                      x2="6.65845"
                      y2="2.5957"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF" />
        <stop offset="0.0209492"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.0838254"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.0899253"
              stop-color="#FFFFFF"
        />
        <stop offset="0.15984"
              stop-color="#FFFFFF"
        />
        <stop offset="0.17204"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.24477"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.251016"
              stop-color="#FFFFFF"
        />
        <stop offset="0.320315"
              stop-color="#FFFFFF"
        />
        <stop offset="0.340022"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.400552"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.410365"
              stop-color="#FFFFFF"
        />
        <stop offset="0.494397"
              stop-color="#FFFFFF"
        />
        <stop offset="0.504525"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.575104"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.581095"
              stop-color="#FFFFFF"
        />
        <stop offset="0.65628"
              stop-color="#FFFFFF"
        />
        <stop offset="0.66801"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.743548"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.748721"
              stop-color="#FFFFFF"
        />
        <stop offset="0.824257"
              stop-color="#FFFFFF"
        />
        <stop offset="0.83787"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.909661"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.912477"
              stop-color="#FFFFFF"
              stop-opacity="0.898358"
        />
        <stop offset="0.97723"
              stop-color="#FFFFFF"
              stop-opacity="0.823752"
        />
        <stop offset="0.985676"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7545_7412"
                      x1="12.6091"
                      y1="25.2847"
                      x2="12.6091"
                      y2="30.2534"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCD4E8" />
        <stop offset="1"
              stop-color="#C9BADD"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7545_7412"
                      x1="15.25"
                      y1="30.2534"
                      x2="15.25"
                      y2="27.769"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A58BC5" />
        <stop offset="1"
              stop-color="#C7B7DD"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint7_radial_7545_7412"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.2288 27.0536) rotate(160.811) scale(4.00668 3.82546)"
      >
        <stop offset="0.851516"
              stop-color="#FFFFFF"
        />
        <stop offset="0.938869"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint8_linear_7545_7412"
                      x1="21.2782"
                      y1="30.1357"
                      x2="26.1854"
                      y2="26.2257"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0284376"
              stop-color="#F8F5FC"
              stop-opacity="0"
        />
        <stop offset="0.214791"
              stop-color="#F8F5FC"
        />
        <stop offset="1"
              stop-color="#F8F5FC"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7545_7412">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
